import { useState } from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { dummy_profile_pic, mobile_icon1, mobile_icon2, mobile_icon3, mobile_icon4, mobile_icon5, mobile_icon6, mobile_icon7 } from "../../assets/assets";
import Logout from "../Profile/components/Logout";
import "./MoreDetails.scss";

const MoreDetails = () => {
  const [show, setShow] = useState(false)
  const countData = useSelector((state: any) => state?.APIData?.agentBusinessCount);
  const Data = useSelector((state: any) => {
    const partnerData = state?.APIData?.partnerData;
    return partnerData && [partnerData].length > 0 ? partnerData : null;
  });

  console.log(Data,"ddddddddddddd");
  const profileData =  Data && Data.partner_profile && Data.partner_profile[0]
  
  
  
  return (
    <section>
      <div className="more-details--wrapper">
        <div className="profile--wrapper-inner">
          <div className="profile--wrapper-headerprofile">
            <div className="profile-image bg-shape">
              <img src={ profileData?.partner_image ? profileData?.partner_image :dummy_profile_pic} />
            </div>
            <h3 className="profile--mainheading mt-3">{profileData.partner_name}</h3>
          </div>
          <div className="profile-tabs">
            <ul className="list-unstyled">
              <Link to={"/app/business"}><li> <img className="me-2" src={mobile_icon1} alt="" /> Businesses ({countData.total_business})</li></Link>
              <Link to={"/app/sub-partner"}><li> <img className="me-2" src={mobile_icon2} alt="" /> Sub Partners ({countData.total_agents})</li></Link>
              <Link to={"/app/payout-reports"}><li> <img className="me-2" src={mobile_icon3} alt="" />Commissions</li></Link>
              <Link to={"/app/calculator"}><li> <img className="me-2" src={mobile_icon4} alt="" /> Calculator</li></Link>
              <Link to={"/app/support"}><li> <img className="me-2" src={mobile_icon5} alt="" />Support</li></Link>
             {Data && Data.show_assets == 1 && <Link to={"/app/assets"}><li> <img className="me-2" src={mobile_icon6} alt="" />Assets</li></Link>}
             <li onClick={() => setShow(true)}> <img className="me-2" src={mobile_icon7} alt="" /> Logout</li>
            </ul>
            <Link to={"/app/profile"}><div className="footer">
                 <span className="fs-14-contentwrap">{profileData.partner_name}</span>
            </div>
            </Link>
          </div>
        </div>
        <Logout show={show} onHide={() => setShow(false)} />
      </div>
    </section>
  );
};

export default MoreDetails;
